"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.CleAbsenteDeLaSurface = exports.LangueNonLivree = void 0;
exports.creerFabriqueTraducteur = creerFabriqueTraducteur;
const intl_messageformat_1 = __importDefault(require("intl-messageformat"));
const langues_1 = require("./langues");
class LangueNonLivree extends Error {
    langue;
    constructor(langue) {
        super(`La langue « ${langue} » n'est pas livrée dans le catalogue partagé`);
        this.langue = langue;
        this.name = 'LangueNonLivree';
    }
}
exports.LangueNonLivree = LangueNonLivree;
/** Une clé hors des espaces de la surface : `F-LNG-02` la refuse avant, ceci l'empêche de planter sans dire pourquoi. */
class CleAbsenteDeLaSurface extends Error {
    cle;
    langue;
    constructor(cle, langue) {
        super(`La clé « ${cle} » n'est pas dans le catalogue de cette surface (${langue})`);
        this.cle = cle;
        this.langue = langue;
        this.name = 'CleAbsenteDeLaSurface';
    }
}
exports.CleAbsenteDeLaSurface = CleAbsenteDeLaSurface;
/**
 * Fabrique de traducteurs sur un catalogue donné.
 *
 * Ce module n'importe aucun texte : c'est ce qui permet à une surface de
 * construire son traducteur sur ses seuls espaces. La clé est fermée par le
 * type `CleTraduction` et le message est réellement interprété comme de l'ICU.
 */
function creerFabriqueTraducteur(catalogues) {
    const messagesCompiles = new Map();
    function messageCompile(langue, cle) {
        const identifiant = `${langue}:${cle}`;
        const existant = messagesCompiles.get(identifiant);
        if (existant !== undefined)
            return existant;
        const texte = catalogues[langue][cle];
        if (texte === undefined)
            throw new CleAbsenteDeLaSurface(cle, langue);
        const compile = new intl_messageformat_1.default(texte, langue);
        messagesCompiles.set(identifiant, compile);
        return compile;
    }
    return (langueRecue) => {
        if (!(0, langues_1.estLangueLivree)(langueRecue))
            throw new LangueNonLivree(langueRecue);
        const langue = langueRecue;
        return {
            langue,
            traduire(cle, valeurs = {}) {
                const resultat = messageCompile(langue, cle).format({ ...valeurs });
                if (typeof resultat !== 'string') {
                    throw new TypeError(`Le message « ${cle} » ne produit pas du texte`);
                }
                return resultat;
            },
        };
    };
}
//# sourceMappingURL=fabrique.js.map